import React, {useState} from "react";
import {deleteItem, saveData} from "../../../helpers/Api";
import {Button, Col, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import ListTable from "../../shared/ListTable";
import {DeleteButton} from "../../../helpers/ButtonHelper";
import {useMutation, useQuery} from "@apollo/client";
import {createAllergyMutation, deleteAllergyMutation, getAllergiesQuery} from "./AllergyQueries";

const AllergyList = ({user}) => {
  const {data, loading, refetch} = useQuery(getAllergiesQuery, {variables: {clientId: user.id}})
  const [flash, setFlash] = useState({});
  const [deleteCall] = useMutation(deleteAllergyMutation, {refetchQueries: refetch})
  const [saveCall] = useMutation(createAllergyMutation)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'createAllergy',
      flash_callback: setFlash,
      success: (res) => {
        refetch()
        event.target.reset()
      }
    })
  }

  const header = <tr>
    <th>Alergen</th>
    <th>Nivel Alergie</th>
    <th className='actions'></th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.name}</td>
      <td>{item.level}</td>
      <td className='actions'>
        <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)}/>
      </td>
    </tr>
  }

  return (
    <div className="container">
      <form onSubmit={onSubmit}>
        <Row className="mb-2">
          <Col>
            <FlashMessage flash={flash}/>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm>
            <label htmlFor="name">Alergen:</label>
            <input type='hidden' name='clientId' className="form-control" id="clientId" value={user.id}/>
            <input type='text' name='name' className="form-control" id="name"/>
          </Col>
          <Col>
            <label htmlFor="level">Nivel:</label>
            <input type='text' name='level' className="form-control" id="level"/>
          </Col>
          <Col className="col-auto">
            <br/>
            <Button type='submit'>Adauga</Button>
          </Col>
        </Row>
      </form>
      <hr/>
      {!loading &&
        <ListTable data={data.allergies} header={header} listItem={listItem} showSearch={false}/>
      }
    </div>
  );
}

export default AllergyList